import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Ends the session and goes to the sign-in page. A page, not just an API call, because the
 * panel (which shares this session but cannot post to this origin) sends
 * its "log out" here.
 */
export function SignOut() {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    // Straight to the sign-in page: home would only send a stranger there.
    void signOut().finally(() => navigate('/signin', { replace: true }));
  }, [signOut, navigate]);
  return null;
}
